"use strict";

exports.__esModule = true;
exports.useCSSEnterLeave = useCSSEnterLeave;

var _react = require("react");

var _reactHooks = require("@okee-uikit/react-hooks");

var _useCreateAnimation = require("./useCreateAnimation");

var _excluded = ["allowLeaveFirst", "disabled", "enter", "leave", "onReady", "onStart", "onEnd", "show"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function useCSSEnterLeave(element, options) {
  var initRef = (0, _react.useRef)(false);

  var allowLeaveFirst = options.allowLeaveFirst,
      disabled = options.disabled,
      _options$enter = options.enter,
      enter = _options$enter === void 0 ? {} : _options$enter,
      _options$leave = options.leave,
      leave = _options$leave === void 0 ? {} : _options$leave,
      onReady = options.onReady,
      onStart = options.onStart,
      onEnd = options.onEnd,
      show = options.show,
      extra = _objectWithoutPropertiesLoose(options, _excluded);

  var handleReady = (0, _reactHooks.useRefCallback)(function (identifier) {
    var _a, _b;

    onReady === null || onReady === void 0 ? void 0 : onReady();
    identifier ? (_a = enter.onReady) === null || _a === void 0 ? void 0 : _a.call(enter) : (_b = leave.onReady) === null || _b === void 0 ? void 0 : _b.call(leave);
  });
  var handleStart = (0, _reactHooks.useRefCallback)(function (identifier) {
    var _a, _b;

    onStart === null || onStart === void 0 ? void 0 : onStart();
    identifier ? (_a = enter.onStart) === null || _a === void 0 ? void 0 : _a.call(enter) : (_b = leave.onStart) === null || _b === void 0 ? void 0 : _b.call(leave);
  });
  var handleEnd = (0, _reactHooks.useRefCallback)(function (identifier, animating) {
    var _a, _b;

    onEnd === null || onEnd === void 0 ? void 0 : onEnd(animating);
    identifier ? (_a = enter.onEnd) === null || _a === void 0 ? void 0 : _a.call(enter, animating) : (_b = leave.onEnd) === null || _b === void 0 ? void 0 : _b.call(leave, animating);
  });
  var animation = (0, _useCreateAnimation.useCreateAnimation)(element, _extends({}, extra, show ? enter : leave, {
    onReady: handleReady,
    onStart: handleStart,
    onEnd: handleEnd
  }));
  (0, _react.useEffect)(function () {
    var init = initRef.current;
    initRef.current = true;

    if (!disabled && (init || show || allowLeaveFirst)) {
      return animation.start(show);
    }
  }, [show]);
  return animation;
}